import {ServiceRequest} from "src/utils/service-request"
import {MOTOR_CADASTRO_OCR_PATH, MOTOR_CADASTRO_PATH, MOTOR_CADASTRO_TEMPORARIO_PATH} from "../utils/api-routes"

class MotorService {
    constructor() {
        this.request = new ServiceRequest()
    }

    async loadCadastros(cetip, versao) {
        const params = new URLSearchParams()

        if (cetip) params.append("CETIP", cetip)
        if (versao) params.append("VersaoDocumento", versao)

        const query = params.toString() ? `?${params.toString()}` : ""

        return this.request.get(`${MOTOR_CADASTRO_PATH}${query}`)
    }

    async loadCadastrosOCR() {
        return this.request.get(`${MOTOR_CADASTRO_OCR_PATH}`)
    }

    async deleteCadastroOCR(ocrId) {
        return this.request.delete(`${MOTOR_CADASTRO_OCR_PATH}/${ocrId}`)
    }

    async createCadastroTemporario(payload) {
        return this.request.post(MOTOR_CADASTRO_TEMPORARIO_PATH, payload)
    }

    async updateCadastroTemporario(cetip, versaoDocumento, payload) {
        const safeCetip = encodeURIComponent(cetip)
        const safeVersao = encodeURIComponent(versaoDocumento)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeCetip}/versao/${safeVersao}`
        return this.request.put(path, payload)
    }

    async getCadastroTemporario(cetip, versaoDocumento) {
        const safeCetip = encodeURIComponent(cetip)
        const safeVersao = encodeURIComponent(versaoDocumento)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeCetip}/versao/${safeVersao}`
        return this.request.get(path)
    }

    async createCadastro(payload) {
        return this.request.post(MOTOR_CADASTRO_PATH, payload)
    }

    async deleteCadastroTemporario(cetip, versaoDocumento) {
        const safeCetip = encodeURIComponent(cetip)
        const safeVersao = encodeURIComponent(versaoDocumento)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeCetip}/versao/${safeVersao}`
        return this.request.delete(path)
    }

    async getCadastro(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}`
        return this.request.get(path)
    }

    async getCadastroCovenants(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/covenants`
        return this.request.get(path)
    }

    async createCadastroCovenant(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/covenants`
        return this.request.post(path, payload)
    }

    async updateCadastroCovenant(id, covenantId, payload) {
        const safeId = encodeURIComponent(id)
        const safeCovId = encodeURIComponent(covenantId)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/covenants/${safeCovId}`
        return this.request.patch(path, payload)
    }

    async deleteCadastroCovenant(id, covenantId) {
        const safeId = encodeURIComponent(id)
        const safeCovId = encodeURIComponent(covenantId)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/covenants/${safeCovId}`
        return this.request.delete(path)
    }

    async updateCadastro(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}`
        return this.request.put(path, payload)
    }

    async deleteCadastro(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}`
        return this.request.delete(path)
    }

    async postUploadOcr(formData) {
        const path = `${MOTOR_CADASTRO_PATH}/ocr`
        return this.request.postFormData(path, formData)
    }
}

export default MotorService
